/* eslint-disable default-case */
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Modal from "react-modal";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import initPage from "../../../utils/initPage";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";

import Template from "../../../template/template";
import Membership from "../../../components/membership/membership";
import Loader from "../../../components/loader/loader";
import Notify from "../../../components/notification/notify";
import { TooltipItem } from "./tooltip";

import "./styles.css";
import Servers from "./servers";

function Rewards() {
  initPage({ title: t("Rewards.Title"), theme: { background: "loyal-bg" } });

  const [loadingCharacters, setLoadingCaracters] = useState(false);
  const [loadingCollect, setLoadingCollect] = useState(false);
  const [alreadyCollecteds, setAlreadyCollecteds] = useState({
    Category: false,
    Daily: false,
    Monthly: false,
    "12Months": false,
  });
  const { type } = useParams();

  const { user } = useSelector((store) => store.auth);
  const { avatar, name, nickname, credits, loyal_member_points } = user;

  const { ApiGetLoyalMember, ApiGetLoyalMemberRewards, ApiRewardsTake, ApiGetCharacters } = useApi();

  const [loyalMember, setLoyalMember] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedServerId, setSelectedServerId] = useState();

  async function getLoyalMember() {
    const { data } = await ApiGetLoyalMember();
    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    data.sort((a, b) => {
      if (a.target_points < b.target_points) return -1;
      if (a.target_points > b.target_points) return 1;
      return 0;
    });

    for (let i = 0; i < data.length; i++) {
      if (
        loyal_member_points >= data[i].target_points &&
        (data[i + 1] ? loyal_member_points < data[i + 1].target_points : true)
      ) {
        setLoyalMember({ ...data[i] });
      }
    }
  }

  useEffect(() => {
    getLoyalMember();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loyal_member_points]);

  const getRewards = useCallback(
    async (loyalMemberCategory, serverId) => {
      setLoading(true);
      const { data } = await ApiGetLoyalMemberRewards(loyalMemberCategory, serverId);

      setLoading(false);
      setRewards(data.items);
    },
    [ApiGetLoyalMemberRewards],
  );

  useEffect(() => {
    setRewards([]);
    if (selectedServerId && loyalMember?.name) {
      getRewards(type || loyalMember?.name, selectedServerId);
    }
  }, [getRewards, loyalMember, selectedServerId, type]);

  const onlyView = type && type !== loyalMember?.name;

  function classColor() {
    const color = type ? type : loyalMember.name;
    switch (color) {
      case "Silver":
        return {
          warp: "sliver-pack",
          iconLarge: "/images/sliver-icon-large.png",
          groupBox: "sliver-style",
          bullets: "/images/bullets-sliver.png",
          l: "s",
          color,
        };
      case "Gold":
        return {
          warp: "gold-pack",
          iconLarge: "/images/gold-ico-large.png",
          groupBox: "gold-style",
          bullets: "/images/bullets-gold.png",
          l: "g",
          color,
        };
      case "Platinum":
        return {
          warp: "platinum-pack",
          iconLarge: "/images/platinum-icon-large.png",
          groupBox: "platinum-style",
          bullets: "/images/bullets-platinum.png",
          l: "p",
          color,
        };
      case "Diamond":
        return {
          warp: "diamond-pack",
          iconLarge: "/images/diamond-icon-large.png",
          groupBox: "diamond-style",
          bullets: "/images/bullets-diamond.png",
          l: "d",
          color,
        };
    }
  }

  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({});
  const [characters, setCharacters] = useState([]);

  function openModal(type) {
    setForm((previous) => ({ ...previous, type }));
    getCharacters(selectedServerId);
    setModalOpen(true);
  }

  function closeModal() {
    setForm({});
    setCharacters([]);
    setModalOpen(false);
  }

  const getCharacters = useCallback(
    async (serverId) => {
      setForm((previous) => ({ ...previous, server: serverId, character: undefined }));
      setCharacters([]);
      setLoadingCaracters(true);
      const { data } = await ApiGetCharacters(serverId);
      setCharacters(data);
      setLoadingCaracters(false);
    },
    [ApiGetCharacters],
  );

  async function onSelectServer(serverId) {
    setSelectedServerId(serverId);
  }

  function onSelectCharacter(e) {
    setForm({ ...form, character: e.target.value });
  }

  async function SubmitTake() {
    setLoadingCollect(true);
    try {
      const { data: successResponse } = await ApiRewardsTake(form);

      setAlreadyCollecteds((previous) => ({ ...previous, [form.type]: true }));
      Notify({ type: "success", message: successResponse });
    } catch (err) {
      Notify({ type: "danger", message: err.response.data });
    }

    setLoadingCollect(false);
    closeModal();
  }

  const customStyles = {
    overlay: {
      zIndex: 999,
      background: "rgb(74 74 74 / 75%)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      background: "none",
    },
  };

  return (
    <Template>
      <Modal isOpen={modalOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Example Modal">
        <div class="modal-box">
          <div class="top-rewards">
            <button onClick={() => setModalOpen(false)} id="btn-closed" class="btn-closed"></button>
          </div>
          <div class="content-rewards">
            <div class="character-select">
              <select
                onChange={onSelectCharacter}
                disabled={loadingCharacters}
                name="selec-character"
                class="selec-character"
              >
                <option value="" disabled selected>
                  {loadingCharacters ? t("General.Loading") : t("General.SelectCharacter")}
                </option>
                {characters.map(({ UserID, NickName }) => (
                  <option value={UserID}>{NickName}</option>
                ))}
              </select>
            </div>

            {form?.server && form?.character && (
              <div class="collect">
                <button disabled={loadingCollect} id="btn-collect" onClick={SubmitTake}>
                  {t("Rewards.Take")}
                </button>
              </div>
            )}

            <div class="footer-rewards">
              <img src="/images/attention.png" alt="" />
              <p>{t("Rewards.Modal.Footer.Message1")}</p>
              <p>{t("Rewards.Modal.Footer.Message1")}</p>
            </div>
          </div>
        </div>
      </Modal>

      {loyalMember && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="loyal-member-warp">
                <div className={`recompensas-warp ${classColor().warp}`}>
                  {/* recompensas warp */}

                  <div className="recompensas-top pad-14-xy">
                    <div className="loyal-oque-warp">
                      <div className="oque-top">
                        <div className="profile-panel-box">
                          <div className="profile-col">
                            <div className="user-name-info">
                              <span className="user-thumb">
                                <img src={classColor().iconLarge} alt="" />
                              </span>
                              <div className="user-name-title text-uppercase">
                                <span className="name">{t("Rewards.Title")}</span>
                                <small>{t("Rewards.Level", { level: classColor().color })}</small>
                              </div>
                            </div>
                            <div className="pack-category-warp">
                              <h5>{t("Rewards.SeeOthers")}</h5>
                              <ul>
                                <li>
                                  <Link to={DefRoutes.RewardsType.replace(":type", "Silver")}>
                                    <img src="/images/sliver-icon-large.png" alt="" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to={DefRoutes.RewardsType.replace(":type", "Gold")}>
                                    <img src="/images/gold-ico-large.png" alt="" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to={DefRoutes.RewardsType.replace(":type", "Platinum")}>
                                    <img src="/images/platinum-icon-large.png" alt="" />
                                  </Link>
                                </li>
                                <li>
                                  <Link to={DefRoutes.RewardsType.replace(":type", "Diamond")}>
                                    <img src="/images/diamond-icon-large.png" alt="" />
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="membership-panel-col">
                            <div className="membership-inner">
                              <div className="user-thumb-info">
                                <div className="user-name-info">
                                  <span className="user-thumb">
                                    <img src={avatar || "/images/user-thumn-m.png"} alt="" />
                                  </span>
                                  <div className="user-name-title">
                                    {nickname && <span className="name">{nickname}</span>}
                                    <small>@{name}</small>
                                  </div>
                                </div>
                              </div>
                              <div className="credit-data">
                                <span className="icon">
                                  <img src="/images/credit-ico-large.png" alt="" />
                                </span>
                                {t("General.YouHave")} <h6>{credits || 0}</h6>
                                <small>{t("General.Credits")}</small>
                              </div>
                              <div className="membership-colwarp black">
                                <Membership user={user} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="recompensas-main pad-14-xy">
                    <div className="pack-grid-warp">
                      <Servers onSelect={onSelectServer} />

                      {rewards.length > 0 && (
                        <ul className="pack-group-list">
                          <li>
                            <div className={`pack-group-box ${classColor().groupBox}`}>
                              <div className="pack-group-box-inside">
                                <div
                                  style={{ display: alreadyCollecteds.Category ? "flex" : "none" }}
                                  className="box-black"
                                  id="box-black"
                                >
                                  <img src="/images/icon_retirado.png" alt="" />
                                </div>

                                <div className="pack-group-header">
                                  <span className="count-number">
                                    <img src={`/images/pack-number-${classColor().l}-1.png`} alt="" />
                                  </span>
                                  <h4>{t("Rewards.Types.One")}</h4>
                                </div>

                                <div className="content-area-box">
                                  <div className="title-text">
                                    <p>{t("Rewards.Types.OneDescription")}</p>
                                  </div>
                                  <div className="presents-list-warp">
                                    <ul>
                                      {rewards
                                        .filter((item) => item.subcategory === "Category")
                                        .map((item) => {
                                          return (
                                            <li>
                                              <div className="presents-media">
                                                <figure>
                                                  <img src={item.image} alt="" />
                                                  <TooltipItem item={item} />

                                                  <span>{item.Count}X</span>
                                                  <figcaption>{item.name}</figcaption>
                                                </figure>
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                  <div className="apply-btn-warp">
                                    <button
                                      type="button"
                                      className="btn btn-retirar"
                                      onClick={() => openModal("Category")}
                                    >
                                      {t("Rewards.Take")}
                                    </button>
                                    <Link to={DefRoutes.RechargeLoyalMember} className="btn btn-tornar">
                                      {t("Rewards.LoyalMember")}
                                    </Link>
                                  </div>
                                </div>

                                <span className="bullets-shap bullets-top-right">
                                  {" "}
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-left">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-right">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className={`pack-group-box ${classColor().groupBox}`}>
                              <div className="pack-group-box-inside">
                                <div
                                  style={{ display: alreadyCollecteds.Daily ? "flex" : "none" }}
                                  className="box-black"
                                  id="box-black"
                                >
                                  <img src="/images/icon_retirado.png" alt="" />
                                </div>

                                <div className="pack-group-header">
                                  <span className="count-number">
                                    <img src={`/images/pack-number-${classColor().l}-2.png`} alt="" />
                                  </span>
                                  <h4>{t("Rewards.Types.Two")}</h4>
                                </div>

                                <div className="content-area-box">
                                  <div className="title-text">
                                    <p>{t("Rewards.Types.TwoDescription")}</p>
                                  </div>
                                  <div className="presents-list-warp">
                                    <ul>
                                      {rewards
                                        .filter((item) => item.subcategory === "Daily")
                                        .map((item) => {
                                          return (
                                            <li>
                                              <div className="presents-media">
                                                <figure>
                                                  <img src={item.image} alt="" />
                                                  <TooltipItem item={item} />

                                                  <span>{item.Count}X</span>
                                                  <figcaption>{item.name}</figcaption>
                                                </figure>
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                  <div className="apply-btn-warp">
                                    <button
                                      type="button"
                                      disabled={onlyView}
                                      className="btn btn-retirar"
                                      onClick={() => openModal("Daily")}
                                    >
                                      {t("Rewards.Take")}
                                    </button>
                                    <Link to={DefRoutes.RechargeLoyalMember} className="btn btn-tornar">
                                      {t("Rewards.LoyalMember")}
                                    </Link>
                                  </div>
                                </div>

                                <span className="bullets-shap bullets-top-right">
                                  {" "}
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-left">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-right">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className={`pack-group-box ${classColor().groupBox}`}>
                              <div className="pack-group-box-inside">
                                <div
                                  style={{ display: alreadyCollecteds.Monthly ? "flex" : "none" }}
                                  className="box-black"
                                  id="box-black"
                                >
                                  <img src="/images/icon_retirado.png" alt="" />
                                </div>

                                <div className="pack-group-header">
                                  <span className="count-number">
                                    <img src={`/images/pack-number-${classColor().l}-3.png`} alt="" />
                                  </span>
                                  <h4>{t("Rewards.Types.Three")}</h4>
                                </div>

                                <div className="content-area-box">
                                  <div className="title-text">
                                    <p>{t("Rewards.Types.ThreeDescription")}</p>
                                  </div>
                                  <div className="presents-list-warp">
                                    <ul>
                                      {rewards
                                        .filter((item) => item.subcategory === "Monthly")
                                        .map((item) => {
                                          return (
                                            <li>
                                              <div className="presents-media">
                                                <figure>
                                                  <img src={item.image} alt="" />
                                                  <TooltipItem item={item} />

                                                  <span>{item.Count}X</span>
                                                  <figcaption>{item.name}</figcaption>
                                                </figure>
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                  <div className="apply-btn-warp">
                                    <button
                                      type="button"
                                      disabled={onlyView}
                                      className="btn btn-retirar"
                                      onClick={() => openModal("Monthly")}
                                    >
                                      {t("Rewards.Take")}
                                    </button>
                                    <Link to={DefRoutes.RechargeLoyalMember} className="btn btn-tornar">
                                      {t("Rewards.LoyalMember")}
                                    </Link>
                                  </div>
                                </div>

                                <span className="bullets-shap bullets-top-right">
                                  {" "}
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-left">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-right">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className={`pack-group-box ${classColor().groupBox}`}>
                              <div className="pack-group-box-inside">
                                <div
                                  style={{ display: alreadyCollecteds["12Months"] ? "flex" : "none" }}
                                  className="box-black"
                                  id="box-black"
                                >
                                  <img src="/images/icon_retirado.png" alt="" />
                                </div>

                                <div className="pack-group-header">
                                  <span className="count-number">
                                    <img src={`/images/pack-number-${classColor().l}-4.png`} alt="" />
                                  </span>
                                  <h4>{t("Rewards.Types.Four")}</h4>
                                </div>

                                <div className="content-area-box">
                                  <div className="title-text">
                                    <p>
                                      {t("Rewards.Types.FourDescription").replace(
                                        "{category}",
                                        type || loyalMember.name,
                                      )}
                                    </p>
                                  </div>
                                  <div className="presents-list-warp">
                                    <ul>
                                      {rewards
                                        .filter((item) => item.subcategory === "12Months")
                                        .map((item) => {
                                          return (
                                            <li>
                                              <div className="presents-media">
                                                <figure>
                                                  <img src={item.image} alt="" />
                                                  <TooltipItem item={item} />

                                                  <span>{item.Count}X</span>
                                                  <figcaption>{item.name}</figcaption>
                                                </figure>
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                  <div className="apply-btn-warp">
                                    <button
                                      type="button"
                                      className="btn btn-retirar"
                                      onClick={() => openModal("12Months")}
                                    >
                                      {t("Rewards.Take")}
                                    </button>
                                    <Link to={DefRoutes.RechargeLoyalMember} className="btn btn-tornar">
                                      {t("Rewards.LoyalMember")}
                                    </Link>
                                  </div>
                                </div>

                                <span className="bullets-shap bullets-top-right">
                                  {" "}
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-left">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                                <span className="bullets-shap bullets-bottom-right">
                                  <img src={classColor().bullets} alt="" />
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>

                  {loading && (
                    <div style={{ textAlign: "center", width: "100%", marginTop: 50 }}>
                      <Loader />
                    </div>
                  )}
                  {/* recompensas warp */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Template>
  );
}

export default Rewards;
